import React from "react";
import { TextField } from "@mui/material";
import { parseDurationHours, durationLabel } from "../../utils/duration";

export default function DurationInput({ value, onChange, maxHours = 24, ...props }) {
    const hours = parseDurationHours(value);
    const valid = hours !== null && hours > 0 && hours <= maxHours;
    const examples = "";
    return (
        <TextField
            {...props}
            type="text"
            label="Vinnutími"
            placeholder="1h12m"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            error={value.trim() !== "" && !valid}
            helperText={valid ? `${durationLabel(hours)} · ${examples}` : value.trim() === "" ? examples : `Sláðu inn tíma yfir 0 og að hámarki ${maxHours} klst. · ${examples}`}
            inputProps={{ autoCapitalize: "none", spellCheck: false }}
        />
    );
}
